
import React from 'react'
import Cookies from 'universal-cookie'
import * as IoIcons from 'react-icons/io';

function CerrarSesion() {
  
  const cookie = new Cookies()

  const cerrarSecion=()=>{
    cookie.remove("id",{ path: "/" })
    cookie.remove("Nombre",{ path: "/" })
    cookie.remove("correo",{ path: "/" })
    cookie.remove("contrasena",{ path: "/" })
    cookie.remove("tipo_Usuario",{ path: "/" })
    cookie.remove("regional",{ path: "/" })
    cookie.remove("area",{ path: "/" })
    window.location="/"
    }
  return (
    <button  className="btn btn-secondary" onClick={cerrarSecion} >Cerrar Sesion  <IoIcons.IoMdLogOut /></button>
  )
}
export default  CerrarSesion;